import { Component, HostBinding, input } from '@angular/core';

@Component({
  selector: 'button[cue-button], a[cue-button]',
  imports: [],
  templateUrl: './button.component.html',
  styleUrls: ['./button.component.scss'],
})
export class ButtonComponent {
  class = input('');
  public variant = input<'primary' | 'danger' | 'secondary' | 'light' | 'control' | 'outlined'>('primary');
  public size = input<'small' | 'tiny' | 'nano' | 'default'>();
  public link = input(false);
  public outlined = input(false);

  @HostBinding('class') get classAttribute(): string {
    let classes = [this.variant(), this.size(), this.class()].filter(Boolean).join(' ');
    if (this.link()) {
      classes += ' link';
    }
    if (this.outlined()) {
      classes += ' outlined';
    }
    return classes;
  }
}
